type Props = {
  label: string;
  selected?: boolean;
  onClick?: () => void;
};

export function Chip({ label, selected, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      className={`focus-ring rounded-full border px-4 py-2 text-sm transition ${selected ? 'border-charcoal bg-charcoal text-warm' : 'border-charcoal/15 bg-warm/60 text-charcoal hover:border-charcoal/35'}`}
    >
      {label}
    </button>
  );
}
